<template>
  <button
    v-tooltip.top="`Insert Table`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor?.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false }).run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="15px"
      width="15px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 9.5H21M3 14.5H21M8 4.5V19.5M6.2 19.5H17.8C18.9201 19.5 19.4802 19.5 19.908 19.282C20.2843 19.0903 20.5903 18.7843 20.782 18.408C21 17.9802 21 17.4201 21 16.3V7.7C21 6.5799 21 6.01984 20.782 5.59202C20.5903 5.21569 20.2843 4.90973 19.908 4.71799C19.4802 4.5 18.9201 4.5 17.8 4.5H6.2C5.0799 4.5 4.51984 4.5 4.09202 4.71799C3.71569 4.90973 3.40973 5.21569 3.21799 5.59202C3 6.01984 3 6.57989 3 7.7V16.3C3 17.4201 3 17.9802 3.21799 18.408C3.40973 18.7843 3.71569 19.0903 4.09202 19.282C4.51984 19.5 5.07989 19.5 6.2 19.5Z"
        stroke="#000000"
        stroke-width="2"
      />
    </svg>
  </button>

  <button
    v-if="editor?.can().addColumnBefore()"
    v-tooltip.top="`Insert Column To The Left`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().addColumnBefore()"
    @click="editor?.chain().focus().addColumnBefore().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
      class="rotate-360"
    >
      <g id="Edit / Add_Column">
        <path
          id="Vector"
          d="M5 17H8M8 17H11M8 17V14M8 17V20M14 21H15C16.1046 21 17 20.1046 17 19V5C17 3.89543 16.1046 3 15 3H13C11.8954 3 11 3.89543 11 5V11"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>

  <button
    v-if="editor?.can().addColumnAfter()"
    v-tooltip.top="`Insert Column To The Right`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().addColumnAfter()"
    @click="editor?.chain().focus().addColumnAfter().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
      class="rotate-180"
    >
      <g id="Edit / Add_Column">
        <path
          id="Vector"
          d="M5 17H8M8 17H11M8 17V14M8 17V20M14 21H15C16.1046 21 17 20.1046 17 19V5C17 3.89543 16.1046 3 15 3H13C11.8954 3 11 3.89543 11 5V11"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>

  <button
    v-if="editor?.can().deleteColumn()"
    v-tooltip.top="`Delete Column`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().deleteColumn()"
    @click="editor?.chain().focus().deleteColumn().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="Edit / Delete_Column">
        <path
          id="Vector"
          d="M10 21H9C7.89543 21 7 20.1046 7 19V5C7 3.89543 7.89543 3 9 3H11C12.1046 3 13 3.89543 13 5V11M19 16H13"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>

  <button
    v-if="editor?.can().addRowAfter()"
    v-tooltip.top="`Insert Row Below`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().addRowAfter()"
    @click="editor?.chain().focus().addRowAfter().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
      class="rotate-180"
    >
      <g id="Edit / Add_Row">
        <path
          id="Vector"
          d="M3 14V15C3 16.1046 3.89543 17 5 17L19 17C20.1046 17 21 16.1046 21 15L21 13C21 11.8954 20.1046 11 19 11H13M10 8H7M7 8H4M7 8V5M7 8V11"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>

  <button
    v-if="editor?.can().addRowBefore()"
    v-tooltip.top="'Insert Row Above'"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().addRowBefore()"
    @click="editor?.chain().focus().addRowBefore().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="Edit / Add_Row">
        <path
          id="Vector"
          d="M3 14V15C3 16.1046 3.89543 17 5 17L19 17C20.1046 17 21 16.1046 21 15L21 13C21 11.8954 20.1046 11 19 11H13M10 8H7M7 8H4M7 8V5M7 8V11"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>

  <button
    v-if="editor?.can().deleteRow()"
    v-tooltip.top="'Delete Row'"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    :disabled="!editor?.can().deleteRow()"
    @click="editor?.chain().focus().deleteRow().run()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15px"
      height="15px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="Edit / Delete_Row">
        <path
          id="Vector"
          d="M14 16H20M21 10V9C21 7.89543 20.1046 7 19 7H5C3.89543 7 3 7.89543 3 9V11C3 12.1046 3.89543 13 5 13H11"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  </button>
</template>

<script setup lang="ts">
const editor = defineModel('editor')
</script>

<style>
.tiptap table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
}

.tiptap td,
.tiptap th {
    min-width: 1em;
    border-bottom: 1px solid #817f7f;
    padding: 3px 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
}

.tiptap th {
    font-weight: bold;
    text-align: left;
    background-color: #f1f3f5;
}

.tiptap .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(200, 200, 255, 0.4);
    pointer-events: none;
}

.tiptap .column-resize-handle {
    position: absolute;
    right: -2px;
    top: 0;
    bottom: -2px;
    width: 4px;
    background-color: #adf;
    pointer-events: none;
}
</style>
